module.exports = __webpack_public_path__ + "static/media/img-2New.dc9ffefd.jpg";